/** Last four PAN digits from a masked card number; blank for current-account numbers. */
export const cardLast4 = (value?: string | null) => {
  const raw = (value || '').trim();
  if (!raw) return '';
  const digits = raw.replace(/\D/g, '');
  if (raw.includes('*')) return digits.length >= 4 ? digits.slice(-4) : '';
  if (digits.length === 4) return digits;
  return '';
};

export const displayCardLast4 = (value?: string | null) => cardLast4(value) || '—';
